import React from 'react';
import { Link } from 'react-router-dom';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import { FormattedDate } from 'react-intl';
import RentalDelivery from './RentalDelivery';
import RentalItemList from './RentalItemList';
import ConnectPaymentBox from './ConnectPaymentBox';
import DetailedAmountPaid from './DetailedAmountPaid';
import DetailedAmountRefunded from './DetailedAmountRefunded';
import Modal from 'Utils/Modal';
import { Alert, MessageBubble, Document, Receipts } from 'Utils/SvgIcons';
import NewDocumentForm from 'Components/documents/NewDocumentForm';
import DisclaimerSignatureModal from 'Utils/DisclaimerSignatureModal';
import { isFinalBalanceDue } from 'HelperFunctions/rentals';
import ShowInventoryImagesModal from './ShowInventoryImagesModal';
import axios from 'axios';
import { ROOT_URL, getAuthToken } from 'Api';
import CurrencyLabel from 'Utils/CurrencyLabel';
import ChangeRequestDetails from './change_request/ChangeRequestDetails';
import moment from 'moment';
import { capitalizeFirstLetter } from 'HelperFunctions/general';
import { shouldHidePrice } from 'HelperFunctions/HidePricing';
import { getDisclaimerSignatureInfo } from 'HelperFunctions/disclaimers';
import { getSignatureFromRental } from 'HelperFunctions/rentalSignature';
import BillingAndPayments from 'Components/cart/BillingAndPayments';
import SurchargeNotice from 'Components/cart/SurchargeNotice';

class Rental extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInventoryImagesModal: false,
      rentalPictures: null,
      transactions: [],
      disclaimerUrl: null,
      isDownloadingInvoice: false,
    };
  }
  componentDidMount() {
    this.fetchTransactions();
  }

  fetchTransactions = () => {
    const {
      rental,
      rental: { location },
    } = this.props;
    rental.token &&
      axios
        .get(
          `${ROOT_URL}/portal/rentals/${rental.token}/transactions/?location_id=${location.id}`
        )
        .then((response) => {
          if (response.data.transactions) {
            this.setState({ transactions: response.data.transactions });
          }
        })
        .catch((error) => {
          console.log(error);
        });
  };
  setDisclaimerUrl = (url) => {
    this.setState({ disclaimerUrl: url });
  }

  handleDownloadInvoice = () => {
    const { rental } = this.props;
    this.setState({ isDownloadingInvoice: true });

    axios
      .post(
        `${ROOT_URL}/portal/rentals/${rental.token}/generate_invoice`,
        { invoice_type: 'static_invoice' },
        { headers: getAuthToken() }
      )
      .then((response) => {
        this.setState({ isDownloadingInvoice: false });
        if (response.data.download_url) {
          // Open the download URL in a new window/tab
          window.open(response.data.download_url, '_blank');
        } else {
          console.error('No download URL in response');
        }
      })
      .catch((error) => {
        console.error('Error downloading invoice:', error);
        this.setState({ isDownloadingInvoice: false });
      });
  };
  handleAddDocument = (values) => {
    const newDocument = {
      document_attributes: {
        name: values.name,
        document_type: values.documentType,
        file: values.file[0],
        visible_to_customer: true,
        expirable: values.expirable,
        expires_at: values.expiresAt,
      },
      _destroy: '0',
    };
    this.props.addDocument(newDocument);
  };
  renderActionButton = (rental) => {
    const { toggleSignModal, togglePayment } = this.props;
    const rentalSignature = getSignatureFromRental(rental, 'customer');
    const { disclaimerSignaturePresent, disclaimerSignatureRequired } =
      getDisclaimerSignatureInfo(rental);

    if (rental.cancelRequested) {
      return (
        <button className='full disabled' disabled>
          Cancellation Pending
        </button>
      );
    } else {
      switch (rental.approvalStatus) {
        case 'draft':
          return (
            <button
              className='full'
              onClick={() => this.handleSubmitQuote(rental)}
            >
              Submit
            </button>
          );
        case 'pending':
        case 'lead':
          return (
            <button className='full disabled' disabled>
              Pending
            </button>
          );
        case 'approved':
          if (
            rental.changeRequest !== null &&
            rental.changeRequest.status === 'pending'
          ) {
            return (
              <button className='full disabled' disabled>
                Changes Requested
              </button>
            );
          } else {
            if (rental.autoBooked) {
              return null;
            } else if (rental.isAllowedToMakePayment) {
              if (isFinalBalanceDue(rental)) {
                return (rental.signatureRequired &&
                  !rental.hasSignature &&
                  !rentalSignature.id) ||
                  (disclaimerSignatureRequired &&
                    !disclaimerSignaturePresent) ? (
                  <button className='btn full signatureRequiredBtn' onClick={toggleSignModal}>
                    Signature Required
                  </button>
                ) : (
                  <button className='full alert' onClick={togglePayment}>
                    Pay Final Balance
                  </button>
                );
              } else {
                return (rental.signatureRequired &&
                  !rental.hasSignature &&
                  !rentalSignature.id) ||
                  (disclaimerSignatureRequired &&
                    !disclaimerSignaturePresent) ? (
                  <button className='btn full signatureRequiredBtn' onClick={toggleSignModal}>
                    Signature Required
                  </button>
                ) : (
                  <button className='full makeAPaymentBtn' style={{ marginBottom: '20px' }} onClick={togglePayment}>
                    Make a Payment
                  </button>
                );
              }
            } else {
              return (
                <button className='full disabled' disabled>
                  Approved
                </button>
              );
            }
          }
        default:
          return null;
      }
    }
  };
  viewPhotos = (e) => {
    let batch_number = e.target.id;
    if (batch_number) {
      axios
        .get(
          `${ROOT_URL}/rentals/${this.props.rental.id}/show_rental_pictures/${batch_number}`,
          {
            headers: {
              'location-id': this.props.rental.locationId,
            },
          }
        )
        .then((response) => {
          this.setState({
            rentalPictures: response.data.rentalPictures,
            showInventoryImagesModal: true,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  render() {
    const {
      fields: {
        errors,
        checkout,
        checkoutWindowEnd,
        checkout_time,
        checkin,
        checkinWindowStart,
        checkin_time,
        sameAsEventDates,
        event_start_date_time,
        event_end,
        delivery_type,
        delivery_address_location_name,
        delivery_address_street_address_1,
        delivery_address_street_address_2,
        delivery_address_city,
        delivery_address_locale,
        delivery_address_postal_code,
        delivery_address_country,
        paymentOpen,
        documentModalOpen,
        signModalOpen,
        carrier_type,
        delivery_tracking_number,
        return_tracking_number,
      },
      rental,
      disclaimerRentalRelationships,
      location,
      customer,
      onDeliveryChangeSubmit,
      onSubmitSignature,
      onPaymentSuccess,
      togglePayment,
      toggleDocumentModal,
      toggleSignModal,
      storefrontShopSetting,
      creditCardPercent,
      getDisclaimer,
    } = this.props;
    const delivery = {
      delivery_type,
      delivery_address_location_name,
      delivery_address_street_address_1,
      delivery_address_street_address_2,
      delivery_address_city,
      delivery_address_locale,
      delivery_address_postal_code,
      delivery_address_country,
      carrier_type,
      delivery_tracking_number,
      return_tracking_number,
    };
    let venue = null;
    if (rental.venueRentalRelationship) {
      venue = rental.venueRentalRelationship.venue;
    }
    const customerNotes = rental.notes.filter((n) => n.visibleToCustomer);
    const { showInventoryImagesModal, rentalPictures, transactions, disclaimerUrl } =
      this.state;
    const changeRequests = rental.changeRequests;
    const hasNotes =
      customerNotes.length > 0 ||
      rental.additionalOrderInfo ||
      rental.additionalDeliveryInfo ||
      changeRequests.length > 0;
    const hideSubtotalPricing = shouldHidePrice(
      rental.approvalStatus,
      storefrontShopSetting
    );

    const { disclaimerSignaturePresent, disclaimerSignatureRequired } =
      getDisclaimerSignatureInfo(rental);

    const rentalSignature = getSignatureFromRental(rental, 'customer');

    // TD1-10300: the surcharge notice must appear ONLY when the "Make a Payment"
    // button renders (same condition as renderActionButton's make-a-payment
    // branch) — moving it out of .actions must not change WHEN it shows.
    const signatureSatisfied = !(
      (rental.signatureRequired &&
        !rental.hasSignature &&
        !rentalSignature.id) ||
      (disclaimerSignatureRequired && !disclaimerSignaturePresent)
    );
    const showSurchargeNotice =
      rental.rentalSetting?.applyCcFee &&
      !rental.cancelRequested &&
      rental.approvalStatus === 'approved' &&
      !(rental.changeRequest && rental.changeRequest.status === 'pending') &&
      !rental.autoBooked &&
      rental.isAllowedToMakePayment &&
      !isFinalBalanceDue(rental) &&
      signatureSatisfied;

    return (
      <div>
        <RentalItemList rental={rental} />

        <section className='summary'>
          <Link to={`/conversations`}>
            <MessageBubble />
          </Link>

          <>
            <div className='billingDetails'>
              {
                !hideSubtotalPricing && (
                  <BillingAndPayments rental={rental} />
                )
              }

              {hideSubtotalPricing ? null : rental.depositComplete ? (
                <></>
              ) : (
                <div>
                  <label>Deposit Due</label>
                  <CurrencyLabel value={rental.minimumDeposit} />
                </div>
              )}

              <div className='date'>
                <label>
                  {delivery.delivery_type === 'customer_pick_up'
                    ? 'Pick Up/Drop Off'
                    : 'Delivery'}
                </label>
                {rental.rentalSetting.hideDeliveryTimes ? (
                  <span>TBD</span>
                ) : (
                  <span>
                    <FormattedDate
                      value={rental.startDate}
                      month='numeric'
                      day='numeric'
                    />
                    {' - '}
                    <FormattedDate
                      value={rental.endDate}
                      month='numeric'
                      year='numeric'
                      day='numeric'
                    />
                  </span>
                )}
              </div>
            </div>

            {isFinalBalanceDue(rental) &&
              rental.autoBillEnabled &&
              rental.autoBillCustomer &&
              rental.autoBillCardInfo && (
                <div className='autoBillDetails'>
                  <div>
                    <label>Final Balance Due</label>
                    <CurrencyLabel value={rental.amountRemaining} />
                  </div>
                  <div>
                    <label>Date of Autobill</label>
                    <FormattedDate
                      day='numeric'
                      month='numeric'
                      year='numeric'
                      value={rental.finalPaymentDueDate}
                    />
                  </div>
                  <div>
                    <label>Autobill Payment Method</label>
                    <span>{rental.autoBillCardInfo}</span>
                  </div>
                </div>
              )}

            <div className='actions'>{this.renderActionButton(rental)}</div>

            {/* TD1-10300: render the surcharge notice below the actions at full
                column width, rather than inside .actions (a themed grid, where
                it was squeezed to ~1/3 width). Gated on showSurchargeNotice so it
                appears in exactly the same states as before (only alongside the
                "Make a Payment" button). */}
            {showSurchargeNotice && (
              <SurchargeNotice className='summarySurchargeNotice' />
            )}

            {!hideSubtotalPricing &&
              isFinalBalanceDue(rental) &&
              !(
                rental.autoBillEnabled &&
                rental.autoBillCustomer &&
                rental.autoBillCardInfo
              ) && (
                <div className='balanceDueDetails'>
                  <Alert />
                  <CurrencyLabel value={rental.amountRemaining} /> - Balance Due (
                  <FormattedDate
                    day='numeric'
                    month='numeric'
                    year='numeric'
                    value={rental.finalPaymentDueDate}
                  />
                  )
                </div>
              )}

            {rental.paymentTerm && rental.paymentTerm !== 'undefined' && (
              <div className='term'>{rental.paymentTerm.replace(/-/g, ' ')}</div>
            )}

            {rental.isRecurringPayment && rental.recurringPaymentData && (
              <div className='recurringPaymentDetails'>
                <div>
                  <label>Recurring Payment Amount</label>
                  <CurrencyLabel
                    value={rental.recurringPaymentData.paymentAmount}
                  />
                </div>
                <div>
                  <label>Start Date</label>
                  <span>
                    {moment(rental.recurringPaymentData.startDate).format(
                      'MM/DD/YYYY'
                    )}
                  </span>
                </div>
                {rental.recurringTransactionInfo &&
                  Object.keys(rental.recurringTransactionInfo)
                    .reverse()
                    .map((itemKey, index) => (
                      <div key={index}>
                        <label>
                          {itemKey === 'endDate'
                            ? 'End Date'
                            : capitalizeFirstLetter(itemKey)}
                        </label>
                        <span>{rental.recurringTransactionInfo[itemKey]}</span>
                      </div>
                    ))}
                <div>
                  <label>Next Payment Due On</label>
                  <span>{rental.recurringPaymentData.nextDueDateOn}</span>
                </div>
              </div>
            )}
          </>
        </section>

        <RentalDelivery
          rental={rental}
          delivery={delivery}
          schedule={rental.schedule}
          hideDeliveryInfo={rental.rentalSetting.hideDeliveryInfo}
          hideDeliveryTimes={rental.rentalSetting.hideDeliveryTimes}
          errors={errors}
          sameAsEventDates={sameAsEventDates}
          checkout={checkout}
          checkoutWindowEnd={checkoutWindowEnd}
          checkout_time={checkout_time}
          checkin={checkin}
          checkinWindowStart={checkinWindowStart}
          checkin_time={checkin_time}
          eventStartDateTime={event_start_date_time}
          eventEndDateTime={event_end}
          onSubmit={onDeliveryChangeSubmit}
        />

        {venue && (
          <section className='venue'>
            <h4>Venue</h4>
            <div>{venue.name}</div>
            <div>{venue.streetAddress1}</div>
            {venue.streetAddress2 && <div># {venue.streetAddress2}</div>}
            <div>
              {venue.city}, {venue.locale} {venue.postalCode}, {venue.country}
            </div>
          </section>
        )}

        <section className='documents'>
          <h4>Documents</h4>
          {rental.documentRentalRelationships.map((d) => {
            let { name, expirable, expiresAt, visibleToCustomer } = d.document;
            if (d.expirable != null) {
              expirable = d.expirable;
              expiresAt = d.expiresAt;
            }
            return (
              visibleToCustomer && (
                <a
                  key={d.id}
                  href={d.document.url}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Document />
                  {name}
                  {expirable &&
                    expiresAt &&
                    expiresAt !== null &&
                    (new Date(expiresAt) <= new Date() ? (
                      <div className='expiration'>
                        <span className='alert'>
                          <Alert />
                          Expired:{' '}
                          <FormattedDate
                            value={expiresAt}
                            month='numeric'
                            year='numeric'
                            day='numeric'
                          />
                        </span>
                      </div>
                    ) : (
                      expirable && (
                        <div className='expiration'>
                          Expires:{' '}
                          <FormattedDate
                            value={expiresAt}
                            month='numeric'
                            year='numeric'
                            day='numeric'
                          />
                        </div>
                      )
                    ))}
                </a>
              )
            );
          })}
          <div className='actions'>
            <button className='full' onClick={toggleDocumentModal}>
              Upload a Document
            </button>
          </div>
        </section>
        {hasNotes && (
          <section className='notes'>
            <h4>Notes</h4>
            {customerNotes.map((note) => (
              <div key={note.id}>
                <FormattedDate
                  value={note.createdAt}
                  month='numeric'
                  year='numeric'
                  day='numeric'
                  hour='numeric'
                  minute='numeric'
                />
                <div
                  onClick={this.viewPhotos}
                  dangerouslySetInnerHTML={{
                    __html: note.message,
                  }}
                />
              </div>
            ))}
            {rental.additionalOrderInfo && (
              <div>
                <p>
                  <strong>Additional Order Info:</strong>
                </p>
                <p>{rental.additionalOrderInfo}</p>
              </div>
            )}
            {rental.additionalDeliveryInfo && (
              <div>
                <p>
                  <strong>Additional Delivery Info:</strong>
                </p>
                <p>{rental.additionalDeliveryInfo}</p>
              </div>
            )}
            <div>
              <ChangeRequestDetails changeRequests={changeRequests} />
            </div>
          </section>
        )}

        <section className='disclaimers'>
          <h4>Disclaimers</h4>
          {rental.disclaimerRentalRelationships.map((disclaimerContainer) => (
            <div className='disclaimersDetails' key={disclaimerContainer.id}>
              <a onClick={() => getDisclaimer( rental.token, disclaimerContainer.id, this.setDisclaimerUrl )}>
                {disclaimerContainer.title}
              </a>
            </div>
          ))}
        </section>

        <section className='payments'>
          <h4>Payments</h4>
          <div className='billingDetails'>
            {rental.payments &&
              rental.payments.length > 0 &&
              rental.payments.map((payment) => {
                if (
                  payment.status !== 'Authorized' &&
                  payment.status !== 'Success'
                ) {
                  return (
                    <DetailedAmountPaid
                      key={payment.id}
                      payment={payment}
                      ownerView={false}
                      recurringTransactionInfo={rental.recurringTransactionInfo}
                    />
                  );
                }
              })}
            {rental.refunds &&
              rental.refunds.length > 0 &&
              rental.refunds.map((refund) => (
                <DetailedAmountRefunded
                  key={refund.id}
                  refund={refund}
                  ownerView={false}
                />
              ))}
          </div>
          {rental.isAllowedToMakePayment && (
            <div className='actions'>
              {(rental.signatureRequired &&
                !rental.hasSignature &&
                !rentalSignature.id) ||
              (disclaimerSignatureRequired && !disclaimerSignaturePresent) ? (
                <button className='btn full signatureRequiredBtn' onClick={toggleSignModal}>
                  Signature Required
                </button>
              ) : (
                <button className='full makeAPaymentBtn' onClick={togglePayment}>
                  Make a Payment
                </button>
              )}
            </div>
          )}
          {transactions && transactions.length > 0 && (
            <div className='ccHolds'>
              <h4>Credit Card Holds</h4>
              {transactions.map((transaction) => {
                if (
                  transaction.status === 'Authorized' ||
                  ((transaction.status === 'Approved' ||
                    transaction.status === 'Success') &&
                    transaction.parentTransactionId != null)
                ) {
                  const ccFee =
                    transaction.amount -
                    transaction.amount *
                      (100 / (100 + Number(creditCardPercent)));
                  return (
                    <div className='authDetails'>
                      <div>
                        {transaction.status === 'Authorized' && (
                          <label>Authorized Holds</label>
                        )}
                        {transaction.status === 'Approved' && (
                          <label>Holds Charged</label>
                        )}
                        {transaction.status === 'Success' && (
                          <label>Holds Released</label>
                        )}
                        <CurrencyLabel value={transaction.amount} />
                        <div>
                          <label>
                            <FormattedDate
                              value={transaction.createdAt}
                              year='numeric'
                              month='numeric'
                              day='numeric'
                            />
                          </label>
                          <label>
                            {capitalizeFirstLetter(
                              transaction.paymentData.type
                            )}
                            {' ' + transaction.paymentData.number}
                          </label>
                          <label style={{ float: 'right', marginRight: '0px' }}>
                            <CurrencyLabel value={ccFee} />
                            {' ' + 'CC Fee'}
                          </label>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          )}
          {/* Only allow download invoice button if the rental is not a quote or pending */}
          {/* card: https://tapgoodsdevelopment.atlassian.net/browse/TD1-9555 */}
          {rental.status !== 'quote' && rental.status !== 'pending' && <div className='actions'>
            <button
              className={`full ${this.state.isDownloadingInvoice ? 'disabled' : ''}`}
              onClick={this.handleDownloadInvoice}
              disabled={this.state.isDownloadingInvoice}
            >
              <Receipts />{' '}
              {this.state.isDownloadingInvoice ? 'Generating Invoice...' : 'Download Invoice'}
            </button>
          </div>}

          <Modal
            title='Disclaimer'
            className='disclaimerModal'
            toggle={() => this.setDisclaimerUrl(null)}
            open={disclaimerUrl !== null}
          >
            <a class="btn full large" href={disclaimerUrl} download>
              Download Disclaimer
            </a>
          </Modal>
          <Modal
            title='Make a Payment'
            className='large paymentModal'
            toggle={togglePayment}
            open={paymentOpen}
          >
            <ConnectPaymentBox
              onPaymentSuccess={onPaymentSuccess}
              rentalId={rental.token}
              rental={rental}
              location={location}
              customer={customer}
            />
          </Modal>
          <Modal
            title='Upload Document'
            toggle={toggleDocumentModal}
            open={documentModalOpen}
          >
            <NewDocumentForm onSubmit={this.handleAddDocument} />
          </Modal>
          <DisclaimerSignatureModal
            open={signModalOpen}
            toggle={toggleSignModal}
            rental={rental}
            disclaimerRentalRelationships={disclaimerRentalRelationships}
            onSubmitSignature={onSubmitSignature}
          />
        </section>
        <ShowInventoryImagesModal
          show={showInventoryImagesModal}
          className='show-inventory-images-modal'
          pictures={rentalPictures}
          title={
            rentalPictures &&
            rentalPictures[0] &&
            rentalPictures[0].humanizePictureType
          }
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { parsedStorefrontSettings, location } = state.locations;
  const storefrontShopSetting = parsedStorefrontSettings.storefrontShopSetting;
  const { creditCardPercent } = location;
  return { storefrontShopSetting, creditCardPercent };
};
export default connect(mapStateToProps, actions)(Rental);
